module.exports = __webpack_public_path__ + "img/ic-import-excel.ebb8282b.svg";